export default "/_assets/linkedin.6d8eb3e2.svg"